import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Posts Community Notice' },
    { value: 2, label: 'Posts Staff Notice' },
    { value: 3, label: 'Posts Global Notice' },
    { value: 4, label: 'Posts Text Notice' },
    { value: 5, label: 'Posts Post' },
    { value: 6, label: 'Billing Statement' },
    { value: 7, label: 'Absence Alert' },
    { value: 8, label: 'NZ MOE Unjustified Absence Alert' },
    { value: 9, label: 'NZ MOE Attendance Period Alert' },
    { value: 10, label: 'NZ MOE Roll Return Pending Alert' },
    { value: 11, label: 'Posts Attendance Note' },
    { value: 12, label: 'Posts Comment' },
    { value: 13, label: 'Posts Student Notice' },
    { value: 14, label: 'Booking Create' },
    { value: 15, label: 'Booking Update' },
    { value: 16, label: 'Booking Delete' },
    { value: 17, label: 'Event Publish' },
    { value: 18, label: 'Event Open' },
    { value: 19, label: 'Event Close' },
    { value: 20, label: 'Event Cancel' },
    { value: 21, label: 'Event Complete' },
    { value: 31, label: 'Event Requires Approval' },
    { value: 32, label: 'Event Cancelled' },
    { value: 34, label: 'Event Daily Reminder' },
    { value: 35, label: 'Event Closure Reminder' },
    { value: 36, label: 'Event Open To Caregivers' },
    { value: 37, label: 'Event Permission Reminder' },
    { value: 38, label: 'Event Approved' },
    { value: 40, label: 'Event Open To Staff' },
    { value: 41, label: 'Report Published' },
    { value: 100, label: 'Password Reset Request' },
    { value: 101, label: 'Text Reply' },
  ],
});
